module.exports = __webpack_public_path__ + "img/350a02a.png";